// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NylR4","questions":"styles_questions__1RBM2","footer":"styles_footer__1z_Gk"};